import { ComponentProps, ReactNode } from "react";
import { Flex, tokens } from "shared/components/Spor";
import { SectionStateContentSize } from "shared/components/states/SectionStateContent";

type StateContentContainerProps = {
  children: ReactNode;
  size?: SectionStateContentSize;
  backgroundColor?: string;
  borderRadius?: string;
};

const containerLayoutBySize = {
  sm: {
    height: "fit-content",
    flexDir: "row",
    justifyContent: "start",
    alignItems: "start",
    gap: tokens.default.size.spacing[1],
  },
  md: {
    flex: "1",
    flexDir: "column",
    justifyContent: "center",
    gap: tokens.default.size.spacing[2],
  },
  lg: {
    flex: "1",
    flexDir: "column",
    justifyContent: "center",
    gap: tokens.default.size.spacing[6],
  },
} satisfies Record<SectionStateContentSize, ComponentProps<typeof Flex>>;

export const StateContentContainer = ({
  children,
  size = "md",
  backgroundColor,
  borderRadius,
}: StateContentContainerProps) => (
  <Flex
    width="100%"
    alignItems="center"
    backgroundColor={backgroundColor ?? "transparent"}
    padding={2}
    borderRadius={borderRadius}
    {...containerLayoutBySize[size]}
  >
    {children}
  </Flex>
);
